<div class="dashboard-content dashboard-content-chat">
    <div class="title">
        <h2>Мой</h2>
        <h1>Чат</h1>
    </div>
    <div class="chat">
        <div class="chat-messages-block">
            <div class="chat-messages" id="chat-messages">
                <ng-container *ngIf="messages">
                    <app-loader *ngIf="!showChat"></app-loader>
                    <div [ngClass]="{'hide': !showChat}" [id]="'message' + i" class="msg" *ngFor="let msg of messages; let i = index;" [class.divider-margin]="i > 0 && compareDates(msg?.send_at, messages[i-1].send_at)">
                        <div [ngClass]="{'chat-message-right': clientID == msg.reply_to, 'chat-message-left': clientID !== msg.reply_to, 'chat-message-unread': msg.read_at == null && clientID == msg.reply_to}"
                             class="chat-message" inViewport (inViewportAction)="updateMsg(msg)">
                            <div *ngIf="i === 0 || (i > 0 && messages[i-1].reply_to !== msg.reply_to || compareDates(msg?.send_at, messages[i-1].send_at)); else elseBlock" class="chat-message-name">
                                {{clientID == msg?.reply_to ? msg?.client_json?.f_name : msg?.agent_json?.f_name}}, {{msg?.send_at | date:'HH:mm'}}
                            </div>
                            <ng-template #elseBlock>
                                <div class="chat-message-name">
                                    {{msg?.send_at | date:'HH:mm'}}
                                </div>
                            </ng-template>
                            {{msg.message}}
                            <ng-container *ngIf="msg.files">
                                <div *ngFor="let file of msg.files; let i = index" class="chat-message-file" (click)="getPathFile($event, file.file)">
                                    <a target="_blank" href="{{file.file}}">{{file.name}}</a>
                                </div>
                            </ng-container>
                        </div>
                        <div *ngIf="i > 0 && compareDates(msg?.send_at, messages[i-1].send_at)" class="divider">{{msg?.send_at | date:'d MMM yyyy'}}</div>
                        <div *ngIf="i === 0" class="divider">{{msg?.send_at | date:'d MMM yyyy'}}</div>
                    </div>
                </ng-container>
            </div>
            <div class="chat-input">
                    <textarea name="chat-input-msg" rows="3" class="chat-input-msg" placeholder="введите сообщение..."
                              [(ngModel)]="newMessage"></textarea>
                <span class="lnr lnr-chevron-right-circle chat-input-send" [class.disabled]="!newMessage?.length" (click)="sendMessage()"></span>
                <input type="file" class="lnr lnr-paperclip chat-input-upload"
                       (change)="uploadFile($event.target.files)">
            </div>
        </div>
    </div>

</div>


